module.exports = __webpack_public_path__ + "img/ai-task-summarization.7664de80.svg";